import React from 'react'
import ReactDOM from 'react-dom'
import log from 'blazar-sentry'

import isBrowser from 'utils/isBrowser'

import * as blazarTracking from '@blazar/tracking'
import * as trackingListeners from 'tracking'

// External reduxbits
import { getReducers } from '@blocket/authentication-fe'
import * as motor from 'external/reduxBits/motor'
import * as privacyNotice from 'external/reduxBits/privacyNotice'
import * as replyTime from 'external/reduxBits/replyTime'
import * as reportAd from 'external/reduxBits/reportAd'
import * as sendmail from 'external/reduxBits/sendmail'
import ServerErrorComponent from 'components/ErrorComponent/ServerErrorComponent'
// Do NOT remove `#creator` markers they are needed for the creator script.
// #creator.importStart
import * as account from './account'
import * as adBlocker from './adBlocker'
import * as autocomplete from './autocomplete'
import * as classified from './classified'
import * as config from './config'
import * as geolocation from './geolocation'
import * as notifications from './notifications'
import * as phoneNumber from './phoneNumber'
import * as quickass from './quickass'
import * as searchInput from './searchInput'
import * as searchParams from './searchParams'
import * as geoPicker from './geoPicker'
import * as toplistings from './toplistings'
import * as tracking from './tracking'
import * as appNexus from './appNexus'

import * as StartPage from './startPage'
import * as contentfulPage from './contentfulPage'
import * as motorContentfulPage from './motor/motorContentfulPage'

// #creator.importEnd

export default {
  ...blazarTracking.createReducer(),
  ...getReducers(),
  // #creator.reducersStart
  account,
  adBlocker,
  appNexus,
  autocomplete,
  classified,
  config,
  geolocation,
  geoPicker,
  motor,
  notifications,
  phoneNumber,
  quickass,
  privacyNotice,
  replyTime,
  reportAd,
  searchInput,
  searchParams,
  sendmail,
  toplistings,
  tracking,
  StartPage,
  contentfulPage,
  motorContentfulPage,
  // #creator.reducersEnd
}

export const reduxMiddlewares = [
  (store) => (next) => (action) => {
    try {
      next(action)
    } catch (error) {
      log.error(new Error('Error occured in redux', error))
      if (isBrowser()) {
        ReactDOM.render(
          <ServerErrorComponent error="500" baseUrl={store.getState().config.urls.base} />,
          document.getElementById('root'),
        )

        // This is to make the browser reload the page when going back from an error.
        // So that a new fresh SPA will be rendered for the user.
        window.addEventListener('popstate', () => {
          window.location.reload()
        })
      }
    }
  },
  log.sentryReduxMiddleware,
  blazarTracking.createReduxMiddleware(trackingListeners),
]
